// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'

import 'core-js/fn/promise/finally'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import styles from './css/custom.module.css'

Vue.use(VueMaterial)
Vue.use(Vuex)

Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {
    usuario: null,
    tickets_filter: null,
    cashflow_filter: null
  },
  mutations: {
    LOGIN_SUCCESS(state, response) {
      state.usuario = response.usuario
    },
    LOGOUT(state) {
      state.usuario = null
    },
    TICKETS_FILTER(state, filter) {
      state.tickets_filter = filter
    },
    CASHFLOW_FILTER(state, filter) {
      state.cashflow_filter = filter
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  data: {
	API_URL: process.env.NODE_ENV === 'development'
	? 'https://api.betmania.app/'
	: 'https://api.betmania.app/'
  }
})



// WEBPACK FOOTER //
// ./src/main.js